"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserSelectionCss = _interopRequireDefault(require("./UserSelection.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalTerms = function LegalTerms(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.legalTerms
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.termsText
  }, "By clicking \u201CNext\u201D button below or any of the links above, I agree with the ", /*#__PURE__*/_react.default.createElement("a", {
    key: "terms-privacy-policy-1",
    style: _UserSelectionCss.default.termsLink,
    href: "https://unitedstatescredit.com/privacy",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Privacy Policy"), " and ", /*#__PURE__*/_react.default.createElement("a", {
    key: "terms-policy",
    style: _UserSelectionCss.default.termsLink,
    href: "https://unitedstatescredit.com/terms",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Terms & Conditions"), ".", " In addition, I consent to receive emails ".concat(email && email !== 'omit' ? "to ".concat(email) : '', "\n            in accordance with the "), /*#__PURE__*/_react.default.createElement("a", {
    key: "terms-privacy-policy-2",
    style: _UserSelectionCss.default.termsLink,
    href: "https://unitedstatescredit.com/privacy",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Privacy Policy"), "."));
};

var _default = (0, _radium.default)(LegalTerms);

exports.default = _default;

//# sourceMappingURL=LegalTerms.jsx.map